<template>
  <div id="app" style="height: 100%; margin: 0;">
    <router-link :key="$route.fullPath" to="/"></router-link>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'app',
    computed:{
      isRouterAlive(){
        return this.$store.state.isRouterAlive // 用来解决路由相同不刷新问题
      }
    }
  }
</script>

<style>
  body {
    margin: 0;
    color: #666;
    font-size: 14px;
    line-height: 1.6em;
    font-family: Arial,Microsoft yahei;
    width: 100%;
    -webkit-touch-callout: none; /*系统默认菜单被禁用*/
    -webkit-user-select: none; /*webkit浏览器*/
    -khtml-user-select: none; /*早起浏览器*/
    -moz-user-select: none; /*火狐浏览器*/
    -ms-user-select: none; /*IE浏览器*/
    user-select: none; /*用户是否能够选中文本*/
  }
  input, select, texteare {
    -webkit-user-select:auto; /*webkit浏览器*/
    user-select: auto; /*用户是否能够选中文本*/
  }
</style>
